import { AsyncActionHandler } from 'action-handler';

export default new AsyncActionHandler({
  name: 'fetch_access_token',
  defaultState: {
    accessToken: null
  },
  handler() {
    return async () => {
      const { authToken: accessToken } = await window.__webview_comms__.get(
        'auth-token'
      );
      return {
        accessToken
      };
    };
  },
  reduce(state, actionData) {
    return actionData;
  }
});
